import React from 'react';
import {Tooltip} from '@mui/material';
import FilledButton from "../../../components/buttons/FilledButton";

function PaymentReminderButton({hasOverdueInvoices, disabled, onClick}) {
    if (!hasOverdueInvoices) {
        return null;
    }

    const noCollectionsEmailTooltip = 'El cliente no tiene mail de cobranzas cargado';

    const button = (
        <span>
            <FilledButton onClick={onClick} disabled={disabled}>
                Recordatorio de pago
            </FilledButton>
        </span>
    );

    if (!disabled) {
        return button;
    }

    return (
        <Tooltip title={noCollectionsEmailTooltip}>
            {button}
        </Tooltip>
    );
}

export default PaymentReminderButton;
